/* eslint-disable react/react-in-jsx-scope */
import FormTextInput from '../elements/FormTextInput'
import { participantInfoDisplayFields } from '../utils/participantInfoFields'

const UploadResultFormContent = ({ values, formDisabled }) => [
  {
    id: 'upload-result-form-details',
    name: 'Upload Participant Results',
    inputs: [
      ...participantInfoDisplayFields(values),
      {
        id: 'virtualProgress',
        size: 12,
        field: (
          <FormTextInput
            type="number"
            name="virtualProgress"
            label="Distance covered (in km)"
            required
            autoComplete="new-virtualProgress"
            disabled={formDisabled}
            InputProps={{
              inputProps: { min: 0, step: 0.01, type: 'number' },
            }}
          />
        ),
      },
    ],
  },
]

export default UploadResultFormContent
